export const services = state => state.getIn(['services', 'entities']);
export const isLoading = state => state.getIn(['services', 'isLoading']);
export const serviceById = (state, id) => services(state).get(String(id));
export const servicesByIds = (state, ids) => ids.map(id => serviceById(state, id));

/**
 * Note: using map of services and not state
 * @param servicesMap
 * @param id
 * @returns {*}
 */
export const nearestBookableServiceById = (servicesMap, id) => {
  const service = servicesMap.get(String(id));
  if (!service) {
    return null;
  }

  if (service.bookable) {
    return service;
  }

  return nearestBookableServiceById(servicesMap, service.parent);
};

/**
 *
 * Note: using map of services and not state
 * @param servicesMap
 * @param ids
 */
export const nearestBookableServicesByIds = (servicesMap, ids) =>
  ids
    .map(id => nearestBookableServiceById(servicesMap, id))
    .filter(v => !!v);
